import * as types from '../../mutation_type'


export default {
  // 商品图片上传处理
  goodsImgUpload({state},res) {
    if(res&&res.length>0) {
      state.goodsImgList = [];
      res.forEach(item => {
        state.goodsImgList.push(item.url);
      })
    } else {
      state.goodsImgList = [];
    }
  },
  // 视频上传处理
  setVideoUrl({state},res) {
    state.videoUrl = res;
  },
  // 音频上传处理
  setVoiceUrl({state},res) {
    state.voiceUrl = res;
  },
  // 编辑器内容上传处理
  setEditorInfo({state},res) {
    state.editorInfo = res;
  },
  // 编辑器内容上传 商品专用
  setGoodsEditor({state},res) {
    if(res.terType == 1) {
      state.goodsDet.pcContent = res.content
    } else {
      state.goodsDet.mobContent = res.content
    }
  },
  setterKindInfo({state},res) { // 设置规格基本信息
    state.kindInfo = res;
  },
  setStockInfo({state},res) { // 设置规格库存信息
    state.stockInfo.saleinv = res.saleInv;
    state.stockInfo.exchangeinv = res.exchangeInv;
    state.stockInfo.shareinv = res.sharingInv;
    state.stockInfo.dailyinv = res.dailyinv;
    state.stockInfo.opendaily = res.isopendayinv?1:0;
  },
  setChannel({state},res) { // 设置规格渠道信息
    state.channelInfo = res;
  },
  // 设置图片地址
  setImgUrl({state},res) { // 设置规格渠道信息
    if(res.url) {
      if(state.imgUrl&&state.imgUrl.length>0) {
        let isIndex = -1;
        state.imgUrl.some((item,index) => {
          if(item.type == res.type) {
            isIndex = index;
            return true;
          }
        })
        if(isIndex != -1) {
          state.imgUrl[isIndex] = res;
        } else {
          state.imgUrl.push(res);
        }
      } else {
        state.imgUrl.push(res);
      }
    } else {
      state.imgUrl = [];
    }
  },
  modifyImgState({state},res) { // 编辑器图片上传状态变化
    state.cheditorImgUpd = res;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/goodsStore/actions/actions.js